import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  location: string;
  profession: string;
  testimonial: string;
  delay?: number;
}
export function TestimonialCard({
  name,
  location,
  profession,
  testimonial,
  delay = 0
}: TestimonialCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.8,
    delay,
    ease: 'easeOut'
  }} className="relative p-8 bg-white/50 backdrop-blur-sm border border-[#1a1a1a]/10 rounded-sm" data-id="element-64">
      {/* Decorative Quote */}
      <div className="absolute top-4 right-4 text-[#D4AF37]/20" data-id="element-65">
        <Quote size={48} strokeWidth={1} data-id="element-66" />
      </div>

      {/* Corner Accents */}
      <div className="absolute top-0 left-0 w-3 h-3 border-t border-l border-[#C8102E]/30" data-id="element-67" />
      <div className="absolute bottom-0 right-0 w-3 h-3 border-b border-r border-[#00A86B]/30" data-id="element-68" />

      <p className="text-[#1a1a1a]/80 leading-relaxed mb-6 font-serif text-base md:text-lg italic relative z-10" data-id="element-69">
        "{testimonial}"
      </p>

      <div className="flex items-center gap-4" data-id="element-70">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#C8102E]/20 to-[#00A86B]/20 flex items-center justify-center" data-id="element-71">
          <span className="text-[#1a1a1a] font-serif font-bold text-lg" data-id="element-72">
            {name.charAt(0)}
          </span>
        </div>
        <div data-id="element-73">
          <p className="font-serif font-bold text-[#1a1a1a]" data-id="element-74">{name}</p>
          <p className="text-sm text-[#1a1a1a]/60" data-id="element-75">{profession}</p>
          <p className="text-xs text-[#1a1a1a]/40" data-id="element-76">{location}</p>
        </div>
      </div>
    </motion.div>;
}